import {useProductDetailsQuery} from "./useProductDetailsQuery";

export const useCallOutQuery = () => {
    const {model: {callOut}} = useProductDetailsQuery();
    return {callOut};
}